document.addEventListener("DOMContentLoaded", function () {
  if (/iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
    document.body.classList.add("is-iphone");
  }
  document.addEventListener("click", function (event) {
    const drawerOverlay = document.querySelector(".drawer_overlay");
    if (event.target.closest(".drawer_btn")) {
      const drawerBtn = event.target.closest(".drawer_btn");
      if (drawerBtn) {
        const nextElement = document.querySelector(".drawer_container");
        if (nextElement) {
          nextElement.classList.toggle("show_container");
          drawerOverlay.classList.add("is-visible");
          document.body.classList.add("overflow-hidden");
        }
      }
    }
    if (event.target.closest(".DrawerClose")) {
      const closeBtn = event.target.closest(".DrawerClose");
      if (closeBtn) {
        const closestDiv = closeBtn.closest(".show_container");
        if (closestDiv) {
          closestDiv.classList.remove("show_container");
          drawerOverlay.classList.remove("is-visible");
          document.body.classList.remove("overflow-hidden");
        }
      }
    }
    if (event.target.closest(".drawer_overlay")) {
      const overlayBtn = event.target.closest(".drawer_overlay");
      if (overlayBtn) {
        const closestDiv = document.querySelector(".show_container");
        if (closestDiv) {
          closestDiv.classList.remove("show_container");
          drawerOverlay.classList.remove("is-visible");
          document.body.classList.remove("overflow-hidden");
        }
      }
    }
  });
});